/**
 * Robin Tele — Theme JS
 *
 * Custom scripts for the Robin Tele theme.
 * The vendor/template JS (ostech.js) is loaded separately via enqueue.php.
 * This file is for your own additions only.
 */

import '../scss/main.scss';

// ── WooCommerce tabs → mobile accordion ──────────────
(function wooTabsAccordion() {
  const MQ = window.matchMedia('(max-width: 991px)');
  let initialized = false;

  function init() {
    const wrapper = document.querySelector('.woocommerce-tabs');
    if (!wrapper || initialized) return;

    const tabs   = wrapper.querySelectorAll('ul.tabs li');
    const panels = wrapper.querySelectorAll('.woocommerce-Tabs-panel, .panel');

    if (!tabs.length || !panels.length) return;
    initialized = true;

    // Strip WooCommerce's inline display:none so CSS can control visibility.
    panels.forEach(function (p) { p.style.display = ''; });

    // Mark wrapper so CSS knows accordion is active.
    wrapper.classList.add('rt-accordion-ready');

    panels.forEach((panel, i) => {
      const label = tabs[i] ? tabs[i].textContent.trim() : 'Tab ' + (i + 1);
      const id    = panel.id || 'wc-tab-panel-' + i;
      panel.id    = id;

      const btn = document.createElement('button');
      btn.type           = 'button';
      btn.className      = 'rt-accordion-toggle';
      btn.textContent    = label;
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', id);

      btn.addEventListener('click', function () {
        const isOpen = btn.classList.contains('is-active');

        // Close all (single-open mode).
        wrapper.querySelectorAll('.rt-accordion-toggle').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-expanded', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('is-active');
          p.style.display = '';
        });

        // Toggle clicked one.
        if (!isOpen) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-active');
          btn.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      });

      panel.parentNode.insertBefore(btn, panel);

      // Open first panel by default.
      if (i === 0) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-active');
      }
    });
  }

  function toggle(e) {
    if (e.matches) init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { toggle(MQ); });
  } else {
    toggle(MQ);
  }

  MQ.addEventListener('change', toggle);
})();
